import Vue from 'vue';
export const eventBus = new Vue({
  methods: {
    startTour() {
      this.$emit('startTour', true);
    },
    displayPricingDialog() {
      this.$emit('showPricingDialog', true);
    }
  }
});
